import type { RbacPermission, RbacResource, RbacScope } from '@gozoki/api-types'

export const RBAC_RESOURCE_LABELS: Record<RbacResource, string> = {
  dashboard: 'Tableau de bord',
  today: "Aujourd'hui",
  carts: 'Paniers',
  categories: 'Catégories',
  products: 'Produits',
  users: 'Utilisateurs',
  promos: 'Campagnes promo',
  'work-concil': 'Partenariats CE',
  notifications: 'Notifications',
  stores: 'Boutiques',
  accounting: 'Comptabilité',
  quality: 'Qualité',
  'cart-control': 'Contrôle panier',
  'daily-sales': 'Ventes journalières',
  sellers: 'Vendeurs',
  cameras: 'Caméras',
  'camera-views': 'Vues caméras',
  sensors: 'Capteurs',
  'hr-planning': 'RH & Planning',
  'real-estate': 'Foncier & travaux',
  roles: 'Rôles',
  'platform-stocks': 'Stock Plateforme',
  'visio-reviews': 'Contrôle Visio',
}

export const RBAC_PERMISSION_TYPE_LABELS: Record<RbacPermission, string> = {
  read: 'Voir',
  edit: 'Éditer',
}

export const RBAC_SCOPE_LABELS: Record<RbacScope, string> = {
  global: 'Global',
  'real-estate-restricted': 'Prez projet',
  store: 'Boutique',
}

export const getRbacResourceLabel = (resource: RbacResource) => RBAC_RESOURCE_LABELS[resource]

export const getRbacPermissionTypeLabel = (permissionType: RbacPermission) =>
  RBAC_PERMISSION_TYPE_LABELS[permissionType]

export const getRbacScopeLabel = (scope: RbacScope) => RBAC_SCOPE_LABELS[scope]
